import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Facet from './Facet';

class CheckboxFacets extends Component {
  
  constructor(props) {
    super(props);
    this.translationUtility = props.translationUtility
  }

  componentWillMount() {
    require('./checkbox-facets.css');
  }

  render() {
    return (
      <div className="checkbox-facets">
        {
          this.props.attributes.map((attr, i) => (
            <Facet 
              key={i}
              onAttributeChange={this.props.onAttributeChange}
              translationUtility={this.props.translationUtility}
              {...attr}
              />
          ))
        }
      </div>
    );
  }

}

CheckboxFacets.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string,
      DisplayName: PropTypes.string,
      Values: PropTypes.arrayOf(PropTypes.shape({
          Name: PropTypes.string,
          Checked: PropTypes.bool,
          Count: PropTypes.number
      }))
  })),
  translationUtility: PropTypes.object.isRequired,
  // onAttributeChange: PropTypes.func,
  // onClearAttributes: PropTypes.func,
  // expandedFacets: PropTypes.arrayOf(PropTypes.string),
  // onToggleFacetExpanded: PropTypes.func,
  // updateOnToggle: PropTypes.bool,
  // showMoreFacets: PropTypes.arrayOf(PropTypes.string),
  // onToggleShowMoreFacet: PropTypes.func,
  onAttributeChange: PropTypes.func
};

export default CheckboxFacets;


// WEBPACK FOOTER //
// ./src/Components/search/Features/CheckboxFacets/index.jsx